/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  LandingPadType_Enum,
  landingPadType_EnumFromJSON,
  landingPadType_EnumToJSON,
} from "../../../../gen/landing_pad/landing_pad_type";
import {
  TrackLandingPadRequestSource_Enum,
  trackLandingPadRequestSource_EnumFromJSON,
  trackLandingPadRequestSource_EnumToJSON,
} from "../../../../gen/landing_pad/track_landing_pad_request_source";

export const protobufPackage = "skills";

export interface TrackLandingPadRequestActionArgs {
  source: TrackLandingPadRequestSource_Enum;
  enableTracker: boolean;
  enableImageSpace: boolean;
  timeoutS: number;
  waitForActiveTrack: boolean;
  landingPadType: LandingPadType_Enum;
}

export interface TrackLandingPadRequestResultData {
}

export interface TrackLandingPadRequestActionStateData {
}

function createBaseTrackLandingPadRequestActionArgs(): TrackLandingPadRequestActionArgs {
  return {
    source: 0,
    enableTracker: false,
    enableImageSpace: false,
    timeoutS: 0,
    waitForActiveTrack: false,
    landingPadType: 0,
  };
}

export const TrackLandingPadRequestActionArgs = {
  encode(message: TrackLandingPadRequestActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.source !== 0) {
      writer.uint32(8).int32(message.source);
    }
    if (message.enableTracker === true) {
      writer.uint32(16).bool(message.enableTracker);
    }
    if (message.enableImageSpace === true) {
      writer.uint32(24).bool(message.enableImageSpace);
    }
    if (message.timeoutS !== 0) {
      writer.uint32(37).float(message.timeoutS);
    }
    if (message.waitForActiveTrack === true) {
      writer.uint32(40).bool(message.waitForActiveTrack);
    }
    if (message.landingPadType !== 0) {
      writer.uint32(48).int32(message.landingPadType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackLandingPadRequestActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackLandingPadRequestActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.source = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.enableTracker = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.enableImageSpace = reader.bool();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.waitForActiveTrack = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.landingPadType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackLandingPadRequestActionArgs {
    return {
      source: isSet(object.source) ? trackLandingPadRequestSource_EnumFromJSON(object.source) : 0,
      enableTracker: isSet(object.enableTracker) ? globalThis.Boolean(object.enableTracker) : false,
      enableImageSpace: isSet(object.enableImageSpace) ? globalThis.Boolean(object.enableImageSpace) : false,
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
      waitForActiveTrack: isSet(object.waitForActiveTrack) ? globalThis.Boolean(object.waitForActiveTrack) : false,
      landingPadType: isSet(object.landingPadType) ? landingPadType_EnumFromJSON(object.landingPadType) : 0,
    };
  },

  toJSON(message: TrackLandingPadRequestActionArgs): unknown {
    const obj: any = {};
    if (message.source !== 0) {
      obj.source = trackLandingPadRequestSource_EnumToJSON(message.source);
    }
    if (message.enableTracker === true) {
      obj.enableTracker = message.enableTracker;
    }
    if (message.enableImageSpace === true) {
      obj.enableImageSpace = message.enableImageSpace;
    }
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    if (message.waitForActiveTrack === true) {
      obj.waitForActiveTrack = message.waitForActiveTrack;
    }
    if (message.landingPadType !== 0) {
      obj.landingPadType = landingPadType_EnumToJSON(message.landingPadType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackLandingPadRequestActionArgs>, I>>(
    base?: I,
  ): TrackLandingPadRequestActionArgs {
    return TrackLandingPadRequestActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackLandingPadRequestActionArgs>, I>>(
    object: I,
  ): TrackLandingPadRequestActionArgs {
    const message = createBaseTrackLandingPadRequestActionArgs();
    message.source = object.source ?? 0;
    message.enableTracker = object.enableTracker ?? false;
    message.enableImageSpace = object.enableImageSpace ?? false;
    message.timeoutS = object.timeoutS ?? 0;
    message.waitForActiveTrack = object.waitForActiveTrack ?? false;
    message.landingPadType = object.landingPadType ?? 0;
    return message;
  },
};

function createBaseTrackLandingPadRequestResultData(): TrackLandingPadRequestResultData {
  return {};
}

export const TrackLandingPadRequestResultData = {
  encode(_: TrackLandingPadRequestResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackLandingPadRequestResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackLandingPadRequestResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrackLandingPadRequestResultData {
    return {};
  },

  toJSON(_: TrackLandingPadRequestResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackLandingPadRequestResultData>, I>>(
    base?: I,
  ): TrackLandingPadRequestResultData {
    return TrackLandingPadRequestResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackLandingPadRequestResultData>, I>>(
    _: I,
  ): TrackLandingPadRequestResultData {
    const message = createBaseTrackLandingPadRequestResultData();
    return message;
  },
};

function createBaseTrackLandingPadRequestActionStateData(): TrackLandingPadRequestActionStateData {
  return {};
}

export const TrackLandingPadRequestActionStateData = {
  encode(_: TrackLandingPadRequestActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackLandingPadRequestActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackLandingPadRequestActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrackLandingPadRequestActionStateData {
    return {};
  },

  toJSON(_: TrackLandingPadRequestActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackLandingPadRequestActionStateData>, I>>(
    base?: I,
  ): TrackLandingPadRequestActionStateData {
    return TrackLandingPadRequestActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackLandingPadRequestActionStateData>, I>>(
    _: I,
  ): TrackLandingPadRequestActionStateData {
    const message = createBaseTrackLandingPadRequestActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
